import React from 'react'
import { Box } from 'rebass'
import typography from '../../../utils/typography'
import createModelNormaliser from '../../../../lib/model/model-to-vehicle-card-normaliser'
import htmlStripper from '../../../../lib/html-stripper'
import slugg from 'slugg'
import Helmet from 'react-helmet'
import createMeta from '../../../utils/meta-creator'
import ContentVehicleMultiCardListing from '../../../components/ContentVehicleMultiCardListing'
import ContentSection from '../../../components/ContentSection'
import ContentSectionHeading from '../../../components/ContentSectionHeading'
import ContentContextNavigation from '../../../components/ContentContextNavigation'
import ContentSectionHero from '../../../components/ContentSectionHero'
import citygateTheme from '../../../theme/'
import getBrandLogo from '../../../../lib/make/brand-logo-mapper'

const createBodyTypeList = (bodyType) => ({
  label: bodyType,
  slug: slugg(bodyType)
})

const formatBodyTypes = (make, models, bodyTypes) => {
  const normaliseModelForVehicleCard = createModelNormaliser(make)
  const bodyTypesGroup = {}

  models.forEach((model) => {
    model.bodyTypes.forEach((bodyTypeId) => {
      const type = bodyTypes.find((type) => type.id === bodyTypeId)
      if (!type) return
      if (!bodyTypesGroup[type.name]) {
        bodyTypesGroup[type.name] = []
      }
      bodyTypesGroup[type.name].push(normaliseModelForVehicleCard(model))
    })
  })

  return bodyTypesGroup
}

const RangeByBodyTypeWidget = ({
  heading,
  description,
  make,
  allModels,
  allBodyTypes
}) => {
  if (Object.keys(make).length === 0 || !allModels) return null
  const vehicles = allModels.filter(
    (model) => model.make === make.id && !model.parentModel
  )

  const bodyTypesGroup = formatBodyTypes(make, vehicles, allBodyTypes)
  const bodyTypesList = allBodyTypes
    .map(({ name }) => createBodyTypeList(name))
    .filter(
      (bodyType) =>
        bodyTypesGroup[bodyType.label] && bodyTypesGroup[bodyType.label].length
    )

  const metaDescription = htmlStripper(description)

  return (
    <>
      <Helmet title={heading} meta={createMeta({ ...make, metaDescription })} />
      <ContentSectionHero
        title={heading}
        bg={{ color: citygateTheme.colors.blue_light }}
        fg={citygateTheme.colors.blue}
      >
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </ContentSectionHero>
      <ContentContextNavigation sections={bodyTypesList} />

      <ContentSection fg="#EEF4F9" bg="#FFFFFF" opacity={0.65}>
        {bodyTypesList.map((bodyType, i) => {
          return (
            <Box
              title={`New ${make.name} ${bodyType.label}`}
              id={bodyType.slug}
              mb={typography.rhythm(1)}
              key={`body-type-${bodyType.slug}`}
            >
              <Box mb={[-30, null, 0]} px={20}>
                <ContentSectionHeading
                  brand={i === 0 && getBrandLogo(make)}
                  title={`${make.name} | ${bodyType.label}`}
                />
              </Box>
              <ContentVehicleMultiCardListing
                vehicles={bodyTypesGroup[bodyType.label]}
                buttons={false}
              />
            </Box>
          )
        })}
      </ContentSection>
    </>
  )
}

export default RangeByBodyTypeWidget
